import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Header from "./components/site/Header";
import Hero from "./components/site/Hero";
import About, { Marquee } from "./components/site/About";
import Services from "./components/site/Services";
import Menu from "./components/site/Menu";
import Gallery from "./components/site/Gallery";
import Contact from "./components/site/Contact";
import Footer from "./components/site/Footer";

const Home = () => {
  return (
    <main data-testid="home-page" className="bg-zp-cream">
      <Header />
      <Hero />
      <Marquee />
      <About />
      <Services />
      <Menu />
      <Gallery />
      <Contact />
      <Footer />
    </main>
  );
};

function App() {
  return (
    <div className="App">
      <Toaster
        position="bottom-center"
        toastOptions={{
          style: {
            background: "#0A2540",
            color: "#FDFBF7",
            border: "1px solid #1A4C7F",
            fontFamily: "Outfit, sans-serif",
          },
        }}
      />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
